import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

import * as User from "../providers/user";
import * as Axios from "../providers/axios";
import { Button, BUTTON_SIZES } from "../components/Button";
import { AuthenticateResponse } from "models/auth";
import AuthInput from "components/AuthInput";
import AuthLayout from "components/AuthLayout";
import { authSubmitButtonStyles } from "utils/constants";

export default function CompanyName() {
  const navigate = useNavigate();
  const { updateUser } = User.useUser();
  const { api } = Axios.useAxios();
  const [submitting, setSubmitting] = React.useState<boolean>(false);
  const [error, setError] = React.useState<string>("");

  const { handleSubmit, handleChange, touched, errors, values } = useFormik({
    initialValues: {
      name: ""
    },
    validationSchema: CompanyNameSchema,
    validateOnChange: true,
    validateOnMount: false,
    validateOnBlur: false,
    onSubmit: async (values: { name: string }) => {
      try {
        setSubmitting(true);

        const response = (await api.post(`/v1/companies`, values).then((r) => ({
          ...r.data,
          access_token: r.headers["authorization"]
        }))) as AuthenticateResponse;

        if (response.id) {
          updateUser(response);

          navigate(`/dashboard`, { state: { showChoosePlan: true } });
        }
      } catch (error: any) {
        setError(error.message);
      } finally {
        setSubmitting(false);
      }
    }
  });

  return (
    <>
      <Helmet>
        <title>Pointment | On-boarding | Company name</title>
        <meta property="og:title" content="Pointment | Authenticate" />
      </Helmet>
      <AuthLayout title="Company name" error={error} setError={setError}>
        <form onSubmit={handleSubmit}>
          <AuthInput
            type="text"
            name="name"
            label="Company name"
            placeholder="name"
            value={values.name}
            onChange={handleChange}
            touched={touched}
            errors={errors}
            autocapitalize="none"
          />

          <div className="flex lg:flex-row flex-col justify-between lg:items-center">
            <Button
              className={`${authSubmitButtonStyles} !w-full`}
              text={"Save"}
              type="submit"
              size={BUTTON_SIZES.MEDIUM}
              submitting={submitting}
              disabledOnSubmit
            />
          </div>
        </form>
      </AuthLayout>
    </>
  );
}

const CompanyNameSchema = Yup.object().shape({
  name: Yup.string().required("This field is required")
});
